import React from 'react';

export const ConfigurationContext = React.createContext();

ConfigurationContext.displayName = 'ConfigurationContext';

export const ConfigurationContextProvider = ConfigurationContext.Provider;
export const ConfigurationContextConsumer = ConfigurationContext.Consumer;

export default ConfigurationContext;
